/** Backend enum values for distributor (DIS company) invoicing. */
export type CompanyInvoiceMode =
  | 'GROUP_DAILY'
  | 'GROUP_WEEKLY'
  | 'INDIVIDUAL_IMMEDIATE';

export const INVOICE_MODE_OPTIONS: { value: CompanyInvoiceMode; label: string }[] = [
  { value: 'GROUP_DAILY', label: 'Group Daily' },
  { value: 'GROUP_WEEKLY', label: 'Group Weekly' },
  { value: 'INDIVIDUAL_IMMEDIATE', label: 'Individual Immediate' },
];

/** Weekly invoice run day (API string tokens). */
export type WeeklyInvoiceDay =
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY'
  | 'SUNDAY';

export const WEEKLY_INVOICE_DAY_OPTIONS: { value: WeeklyInvoiceDay; label: string }[] = [
  { value: 'MONDAY', label: 'Monday' },
  { value: 'TUESDAY', label: 'Tuesday' },
  { value: 'WEDNESDAY', label: 'Wednesday' },
  { value: 'THURSDAY', label: 'Thursday' },
  { value: 'FRIDAY', label: 'Friday' },
  { value: 'SATURDAY', label: 'Saturday' },
  { value: 'SUNDAY', label: 'Sunday' },
];

export function invoiceModeLabel(
  mode: string | null | undefined
): string {
  if (!mode) return '-';
  const row = INVOICE_MODE_OPTIONS.find((o) => o.value === mode);
  return row ? row.label : mode;
}

export function weeklyInvoiceDayLabel(
  day: string | null | undefined
): string {
  if (!day) return '-';
  const row = WEEKLY_INVOICE_DAY_OPTIONS.find((o) => o.value === day);
  return row ? row.label : day;
}

/** Normalise API 0/1/boolean/string to display. */
export function formatCompanyActive(
  v: boolean | number | string | null | undefined
): string {
  if (v === null || v === undefined) return '-';
  if (typeof v === 'boolean') return v ? 'Yes' : 'No';
  if (typeof v === 'number') return v ? 'Yes' : 'No';
  const s = String(v).toLowerCase();
  if (s === '1' || s === 'true' || s === 'yes') return 'Yes';
  if (s === '0' || s === 'false' || s === 'no') return 'No';
  return String(v);
}
